import { PropsObject, typeConfigs } from '~api/utils/sanitizeData';

interface IProduct {
    thumb: string;
    altThumb: string[];
    name: string;
    description: string;
    skuLabel: string;
    size: string;
    shade: string;
    shadeCode: string;
    url: string;
    price: number;
    productId: string;
    readonly?: boolean;
    isSample: boolean;
    isPricedSample: boolean;
    baseName: string;
    maxAllowedQty?: number;
    isHazmat?: boolean;
}

export const ProductValidationConfig: PropsObject = {
    thumb: typeConfigs.string(),
    name: typeConfigs.string(),
    description: typeConfigs.string(),
    skuLabel: typeConfigs.string(),
    size: typeConfigs.string(),
    shade: typeConfigs.string(),
    shadeCode: typeConfigs.string(),
    url: typeConfigs.string(),
    price: typeConfigs.number(),
    productId: typeConfigs.string(),
    isSample: typeConfigs.boolean(),
    isPricedSample: typeConfigs.boolean(),
    baseName: typeConfigs.string()
};

export default IProduct;
